import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_ADMIN_URL;

export const createRazorpayOrder = async (amount, userId, orderId) => {
  return await axios.post(`${BASE_URL}/create-razorpay-order`, {
    amount,
    currency: "INR",
    user_id: userId,
    order_id: orderId,
  });
};

export const verifyPayment = async (paymentData) => {
  return await axios.post(`${BASE_URL}/verify-payment`, paymentData);
};

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

export const fetchOrdersByStatus = async (userId, status) => {
  try {
    const response = await axios.get(`${BASE_URL}/orders/${userId}/status/${status}`, getAuthHeaders());
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching orders by status:', error);
    throw error;
  }
};

export const fetchAllOrders = async (userId) => {
  try {
    const response = await axios.get(`${BASE_URL}/orders/user/${userId}`, getAuthHeaders());
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching all orders:', error);
    throw error;
  }
};